export default __webpack_public_path__ + "static/media/gloves3.07bba27e.jpg";